/** Matches resource detail GET endpoints (space, folder, task) by their exact API path. */
export const RESOURCE_URL_PATTERN =
  /\/api\/v1\/(spaces\/\d+|spaces\/\d+\/folders\/\d+|tasks\/\d+)$/;

/** Loose URL pattern — accepts http/https, bare domains, IP addresses. */
export const URL_PATTERN =
  /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(:\d+)?(\/[^\s]*)?(\?[^\s]*)?(#[^\s]*)?$/i;
